export default {
    approvalFlow: {
        cooperative: {
            delete: 'Supprimer la Coopérative',
            deactivate: 'Désactiver la Coopérative',
            activate: 'Activer la Coopérative',
            add: 'Ajouter une Nouvelle Coopérative',
            edit: 'Modifier la Coopérative',
            cooperativeName: 'Nom de la Coopérative',
            membershipPlan: 'Plan d\'Adhésion',
            primaryContact: 'Contact Principal',
            firstName: 'Prénom',
            lastName: 'Nom de Famille',
            phoneNumber: 'Numéro de Téléphone',
            email: 'Email',
            location: 'Localisation',
            country: 'Pays',
            provinceState: 'Province/État',
            regionDistrict: 'Région/District',
            villageTownCity: 'Village/Ville',
            address: 'Adresse',
            businessInformation: 'Informations Commerciales',
            interestedCommodities: 'Produits/Commodités d\'Intérêt',
            coffee: 'Café',
            cacao: 'Cacao',
            landRegistered: 'Quelle superficie sera enregistrée ? (en hectares)',
            userType: 'Type d\'Utilisateur',
            exporter: 'Exportateur',
            cooperative: 'Coopérative',
            bothOfThem: 'Les Deux',
            uploadLogo: 'Télécharger une copie du Logo',
            uploadLogoButton: 'TÉLÉCHARGER LOGO',
            enterHere: 'Entrez ici',
            select: 'Sélectionner',
            cooperativeNameRequired: 'Le nom de la coopérative est requis',
            firstNameRequired: 'Le prénom est requis',
            emailRequired: 'L\'email est requis',
            invalidEmail: 'Email invalide',
            required: 'Requis',
            pleaseUploadValidImage: 'Veuillez télécharger un fichier image valide',
            errorPreparingData: 'Erreur lors de la préparation des données',
            cancel: 'Annuler',
            save: 'Enregistrer',
            update: 'Mettre à jour',
            listOfCooperatives: 'Liste des Coopératives',
            addCooperatives: 'Ajouter des Coopératives',
            loadingData: 'Chargement des données...',
            search: 'Rechercher',
            type: 'Type',
            cooperativeTypeInformation: 'Informations sur le Type de Coopérative',
            all: 'Tous',
            of: 'de',
            active: 'Actif',
            unregistered: 'Non Enregistré',
            deactivated: 'Désactivé',
            view: 'Voir',
            confirmDelete: 'Confirmer la Suppression',
            areYouSureDeleteCooperative: 'Êtes-vous sûr de vouloir supprimer cette coopérative ?',
            updatedSuccessfully: 'Mis à jour avec succès',
            createdSuccessfully: 'Créé avec succès',
            errorFetchingCooperativeDetails: 'Erreur lors de la récupération des détails de la coopérative',
            errorSavingCooperative: 'Erreur lors de la sauvegarde de la coopérative',
            errorFetchingCooperativesData: 'Erreur lors de la récupération des données des coopératives',
            cooperativeDeactivatedSuccessfully: 'Coopérative désactivée avec succès',
            errorDeactivatingCooperative: 'Erreur lors de la désactivation de la coopérative',
            cooperativeDeletedSuccessfully: 'Coopérative supprimée avec succès',
            errorDeletingCooperative: 'Erreur lors de la suppression de la coopérative',
            noOfFarms: 'No. de Fermes',
            cropsProducts: 'Cultures/Produits',
            status: 'Statut',
            actions: 'Actions',
            cooperativeAndExporter: 'Coopérative + Exportateur',
            cooperativeActivatedSuccessfully: 'Coopérative activée avec succès',
            back: 'Retour',
            commoditiesProducts: 'Detail Coopérative',
            cooperativeEmail: 'Email Coopérative',
            cooperativePhoneNumber: 'Nomor Telepon Coopérative',
            logo: 'Logo',
            advanced: 'Avancé',

             // Tooltips
             statusTT: 'Statut de la coopérative dans le système (e.g., Active, Deactivated, Unregistered).',
             logoTT: 'Image officielle ou symbole du logo de l\'organisation pour la marque sur les rapports/pages QR.',
             cooperativeNameTT: 'Nom légal enregistré de la coopérative, utilisé dans tous les enregistrements de conformité et rapports.',
             primaryContactTT: 'Nom du contact, email, téléphone.',
             locationTT: 'Filtrer par texte de localisation (pays/province/ville).',
             membershipPlanTT: 'Le plan ou l\'accord qui définit les termes et conditions de la membership dans la coopérative.',
             countryTT: 'Le pays où la coopérative est enregistrée et opére. Cela aide à aligner les rapports avec les réglementations nationales.',
             provinceStateTT: 'La province ou l\'état où la coopérative est enregistrée et opére. Cela aide à aligner les rapports avec les réglementations régionales.',
             regionDistrictTT: 'La région ou le district où la coopérative est basée. Cela aide à garantir une identification précise au niveau communautaire.',
             villageTownCityTT: 'Le nom du lieu local (village, ville) où la coopérative est basée. Cela garantit une identification précise au niveau communautaire.',
             addressTT: 'L\'adresse physique ou postale de la coopérative. Cela devrait inclure les détails de la rue, si disponibles, pour une référence précise dans les rapports.',
             interestedCommoditiesTT: 'Affiche le code et le nom du produit associé au rapport. Ce champ aide les utilisateurs à comprendre quel produit est lié au rapport.',
             userTypeTT: 'Filtrer les résultats par rôle/type de coopérative.',
        },
    },
};
